import sharedDatasInstance from "../sharedDatas";
import { mutation_add_lastActivity_byUserId,mutation_delete_lastActivity } from "../mutations/lastActivityMutations";
import { query_lastActivity_byUserId } from "../query/lastActivityQueries";
import { useMutation,useQuery } from "@1f/react-sdk";

export const LastActivityApi = () => {
    const tenantId = sharedDatasInstance.getPropertyByName("tenantId");    
    const aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    const loggedUserId = sharedDatasInstance.getPropertyByName("userId");
    const apiAddLastActivity = useMutation(mutation_add_lastActivity_byUserId, {
        graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });
    const apiDeleteLastActivity = useMutation(mutation_delete_lastActivity, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
    });   
    const apiUserLastActivity = useQuery(
        query_lastActivity_byUserId,
        { tenantId: tenantId, userId: loggedUserId },
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );

    async function UpdateLastActivity(path,entityId = "",entityName = "") {
        try {
            await apiDeleteLastActivity.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                userId: loggedUserId,
            });
            await apiAddLastActivity.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                path: path,
                entityId: entityId,
                entityName: entityName,
            });   
        } catch (error) {
            throw new Error("Impossibile aggiornare l'ultima attività utente: " + error.message);            
        }        
    }
    async function GetLastActivity(tenantId,aziendaId,userId) {
        try {
            let lastActivityResponse = await apiUserLastActivity.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                userId: userId
            })
            if(lastActivityResponse && lastActivityResponse.data && lastActivityResponse.data.data && lastActivityResponse.data.data.user_lastactivity.length > 0){
                return lastActivityResponse.data.data.user_lastactivity[0]
            }
        } catch (error) {
            throw new Error("Impossibile recuperare l'ultima attività utente: " + error.message);
        }
    }

    return {
        UpdateLastActivity,
        GetLastActivity
    }
}